// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"09bc0630","234":"83ff503b","359":"e7fb6ab9","361":"7ca9533c"}[chunkId] + ".chunk.js";
};